import InfiniteCarousel from '../ui/InfiniteCarousel.jsx';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { resolvePoKName } from '../../utils/domainUtils.js';
import { useLocalizedPath } from '../../hooks/useLocalizedPath.jsx';
import { companies as companiesList } from '../../utils/companies.js';
import { PURPLE, FG_2 } from '../sections/theme.js';
import { ArrowIcon } from '../sections/ArrowIcon.jsx';

const companiesOnCarrousel = companiesList.filter((c) => c.carrousel);

export default function CompaniesList() {
    const { t } = useTranslation();
    const { companies } = useLocalizedPath();

    return (
        <Box component="section" sx={{ width: '100%', overflow: 'hidden', py: { xs: 4, md: 6 } }}>
            <Container maxWidth="lg">
                <Typography
                    component="h2"
                    sx={{
                        fontSize: '0.9rem',
                        fontWeight: 600,
                        textAlign: 'center',
                        color: FG_2,
                        mb: 3.75,
                    }}
                >
                    {t('home.companies.title', { POK_NAME: resolvePoKName() })}
                </Typography>
            </Container>
            <InfiniteCarousel images={companiesOnCarrousel} />
            <Stack
                sx={{
                    alignItems: 'center',
                    mt: 3.5,
                }}
            >
                <Button
                    component="a"
                    href={companies()}
                    variant="text"
                    endIcon={<ArrowIcon />}
                    sx={{
                        color: PURPLE,
                        px: 0,
                        minWidth: 0,
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: '0.9375rem',
                        '&:hover': { background: 'transparent', color: '#3F1C84' },
                    }}
                >
                    {t('home.companies.more')}
                </Button>
            </Stack>
        </Box>
    );
}
